import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.door.open');
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { KioskContext, MeetingLocation } from "src/libs/portal/kiosk/context";

@Component({
    selector: 'wiz-portal-door-open',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.door.open/view.scss */
:host {
  display: block;
}`],
})
export class PortalDoorOpenComponent implements OnInit, OnDestroy {
    public doorState: 'ready' | 'opening' | 'opened' = 'ready';
    public timeText: string = '--:--';
    public dateText: string = '';
    public meetingLocation: MeetingLocation | null = null;
    public showLocationSelector: boolean = false;

    private doorTimer: any = null;
    private clockTimer: any = null;
    private destroyed: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private ref: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init(null as any);
        this.meetingLocation = KioskContext.loadMeetingLocation();
        KioskContext.loadMeetingContext();
        this.showLocationSelector = !this.meetingLocation;
        this.updateClock();
        this.clockTimer = setInterval(() => this.updateClock(), 1000 * 30);
    }

    public ngOnDestroy() {
        this.destroyed = true;
        if (this.doorTimer) clearTimeout(this.doorTimer);
        if (this.clockTimer) clearInterval(this.clockTimer);
    }

    public onLocationChange(location: MeetingLocation) {
        this.meetingLocation = location;
        this.showLocationSelector = false;
        this.render();
    }

    public closeLocationSelector() {
        if (!this.meetingLocation) return;

        this.showLocationSelector = false;
        this.render();
    }

    public changeMeetingLocation() {
        this.showLocationSelector = true;
        this.render();
    }

    public goHome() {
        this.service.href('/kiosk/main');
    }

    public doorLabel() {
        if (this.doorState === 'opening') return '문 여는 중...';
        if (this.doorState === 'opened') return '문이 열렸습니다';
        return '문 열기';
    }

    public async openDoor() {
        if (this.doorState === 'opening') return;

        const roomNo = this.meetingLocation?.room || null;
        const doorNo = KioskContext.getDoorNo(roomNo);
        if (!roomNo || !doorNo) {
            this.showLocationSelector = true;
            this.render();
            await this.showError('호실을 먼저 선택해주세요.');
            return;
        }

        if (this.doorTimer) clearTimeout(this.doorTimer);

        this.doorState = 'opening';
        this.render();

        try {
            const response: any = await wiz.call('open', {
                room: roomNo,
                door: doorNo
            });

            if (response?.code !== 200) {
                throw new Error(this.getErrorMessage(response?.data));
            }

            this.doorState = 'opened';
            this.render();

            this.doorTimer = setTimeout(() => {
                this.doorState = 'ready';
                this.render();
            }, 1800);
        } catch (error) {
            this.doorState = 'ready';
            this.render();
            await this.showError(this.getErrorMessage(error));
        }
    }

    private updateClock() {
        const clock = KioskContext.clockText();
        this.timeText = clock.timeText;
        this.dateText = clock.dateText;
        this.render();
    }

    private render() {
        if (this.destroyed) return;

        setTimeout(() => {
            if (this.destroyed) return;

            this.ref.detectChanges();
            if (this.service && this.service.inited) this.service.render();
        }, 0);
    }

    private getErrorMessage(error: any, fallback: string = '문열기에 실패했습니다.') {
        if (!error) return fallback;
        if (typeof error === 'string') return error;
        if (error.message) return error.message;

        return fallback;
    }

    private async showError(message: string, fallback: string = '요청에 실패했습니다.') {
        const errorMessage = message || fallback;
        if (this.service?.modal?.error) {
            await this.service.modal.error(errorMessage);
            return;
        }

        window.alert(errorMessage);
    }
}

export default PortalDoorOpenComponent;